import React, { useState } from 'react';
import { Popover, Box, Typography, List, ListItem, ListItemText, Chip, Paper, Tooltip } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { useStyles } from './PossibleRepeatedWarningButton.style';
import PossibleRepeatedWarningButtonProperties from './PossibleRepeatedWarningButtonProperties';

const PossibleRepeatedWarningButton: React.FC<PossibleRepeatedWarningButtonProperties> = ({
    possiblyRepeated = [],
    className = '',
    tooltipText = 'Atención'
}) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

    const handleClick = (event: React.MouseEvent<SVGSVGElement>) => {
        setAnchorEl(event.currentTarget as unknown as HTMLDivElement);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'repeated-shipments-popover' : undefined;

    // Se não houver possíveis repetições, não renderiza nada
    if (!possiblyRepeated || possiblyRepeated.length === 0) {
        return null;
    }

    return (
        <>
            <Tooltip title={tooltipText}>
                <WarningIcon 
                    style={{ fontSize: 20 }} 
                    className={`${classes.details_icon} ${className}`}
                    onClick={handleClick}
                />
            </Tooltip>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Paper className={classes.popoverContent}>
                    <Box className={classes.popoverHeader}>
                        <WarningIcon className={classes.popoverWarningIcon} />
                        <Typography variant="h6" className={classes.popoverTitle}>
                            Posibles Envíos Repetidos
                        </Typography>
                    </Box>

                    <Box className={classes.popoverBody}>
                        <Typography variant="body2" className={classes.popoverDescription}>
                            Las siguentes órdenes podrían ser envíos repetidos.
                        </Typography>

                        <List className={classes.ordersList}>
                            {possiblyRepeated.map((orderNumber, index) => (
                                <ListItem key={index} className={classes.listItem}>
                                    <ListItemText
                                        primary={
                                            <Chip
                                                label={orderNumber}
                                                variant="outlined"
                                                color="warning"
                                                size="small"
                                                className={classes.orderChip}
                                            />
                                        }
                                    />
                                </ListItem>
                            ))}
                        </List>

                        <Typography variant="caption" className={classes.popoverFooter}>
                            Por favor, revise antes de proceder.
                        </Typography>
                    </Box>
                </Paper>
            </Popover>
        </>
    );
};

export default PossibleRepeatedWarningButton;
